import { handleActions } from "redux-actions";
import {
    BRAND_PROFILE_CATALOGS_SUCCESS,
    CATALOG,
    CATALOG_FAILURE,
    CATALOG_REQUEST,
    CATALOG_RESET,
    CATALOG_SUCCESS,
    PAGE_LEAVE,
    CATALOG_UPDATE,
    CATALOG_ENTRIES_REFRESH,
} from "constants/action-types";

const initialState = {
    initialized: false,
    entities: {},
    result: [],
    isFetching: false,
    isUpdating: false,
    forceRefresh: false,
    error: undefined,
};

const catalogReducer = handleActions(
    {
        [CATALOG_REQUEST]: (state, action) => ({
            ...state,
            error: undefined,
            initialized: true,
            ...(action?.isBackground ? {} : { isFetching: true }),
        }),
        [CATALOG_UPDATE]: (state) => {
            return Object.assign({}, state, {
                isUpdating: true,
            });
        },
        [CATALOG_SUCCESS]: (state, action) => ({
            ...state,
            ...(action.isBackground ? {} : { isFetching: false, isUpdating: false }),
            ...action.data,
        }),
        [CATALOG_FAILURE]: (state, error) => {
            return Object.assign({}, state, {
                isFetching: false,
                isUpdating: false,
                error: error,
                entities: initialState.entities,
                result: initialState.result,
            });
        },
        [PAGE_LEAVE]: () => {
            return initialState;
        },
        [BRAND_PROFILE_CATALOGS_SUCCESS]: (state) => {
            return Object.assign({}, state, {
                isFetching: false,
            });
        },
        [CATALOG.SET_PROCESSING]: (state, { payload }) => {
            const { catalogId, processing } = payload;
            const current = state.entities?.catalogs?.[catalogId]?.set("processing", processing);

            if (!current) {
                return state;
            }
            return {
                ...state,
                entities: {
                    ...state.entities,
                    catalogs: { ...state.entities.catalogs, [catalogId]: current },
                },
            };
        },
        [CATALOG_ENTRIES_REFRESH]: (state, { payload }) => {
            const { forceRefresh } = payload;
            return {
                ...state,
                forceRefresh,
            };
        },
        [CATALOG_RESET]: () => {
            return initialState;
        },
    },
    initialState
);

export default catalogReducer;
